import { Routes } from '@angular/router';
import { NotFoundComponent } from './_pages/not-found/not-found.component';
import { CombinedMainGuard } from './global/guards/combined-main.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadComponent: () => import('./_pages/login/login.component').then(mod => mod.LoginComponent)
    },
    {
        path: 'change',
        loadComponent: () => import('./_pages/change/change.component').then(mod => mod.ChangeComponent)
    },
    {
        path: 'training',
        loadComponent: () => import('./_pages/training/training.component').then(mod => mod.TrainingComponent)
    },
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: '',
        canActivate: [CombinedMainGuard],
        pathMatch: 'prefix',
        loadComponent: () => import('./_pages/organizer/organizer.component').then(mod => mod.OrganizerComponent),
        loadChildren: () => import('./_pages/organizer/organizer.routes').then(m => m.ORGANIZER_ROUTES)
    },
    {
        path: '**',
        redirectTo: '404'
    }
];
